import WebHome from './WebHome'
import AppHome from './AppHome'
import { isCordova } from 'src/env'

const Home = isCordova ? AppHome : WebHome

export default Home
